export default __webpack_public_path__ + "static/media/css-logo.f7a3400b.png";